var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagUsa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 60,
    height: 60,
    transform: "translate(1981 3495)",
    fill: "#fff",
    opacity: 0.41
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_USA",
    transform: "translate(-1981 -3495)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag_eua",
    transform: "translate(1981 3495)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_420",
    "data-name": "Ret\\xE2ngulo 420",
    width: 102.842,
    height: 4.613,
    transform: "translate(0 55.375)",
    fill: "#cb001c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_421",
    "data-name": "Ret\\xE2ngulo 421",
    width: 102.842,
    height: 4.615,
    transform: "translate(0 50.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_422",
    "data-name": "Ret\\xE2ngulo 422",
    width: 102.842,
    height: 4.611,
    transform: "translate(0 46.148)",
    fill: "#cb001c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_423",
    "data-name": "Ret\\xE2ngulo 423",
    width: 102.842,
    height: 4.613,
    transform: "translate(0 41.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_424",
    "data-name": "Ret\\xE2ngulo 424",
    width: 102.842,
    height: 4.618,
    transform: "translate(0 36.917)",
    fill: "#cb001c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_425",
    "data-name": "Ret\\xE2ngulo 425",
    width: 102.842,
    height: 4.61,
    transform: "translate(0 32.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_426",
    "data-name": "Ret\\xE2ngulo 426",
    width: 102.842,
    height: 4.62,
    transform: "translate(0 27.688)",
    fill: "#cb001c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_427",
    "data-name": "Ret\\xE2ngulo 427",
    width: 102.842,
    height: 4.61,
    transform: "translate(0 23.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_428",
    "data-name": "Ret\\xE2ngulo 428",
    width: 102.842,
    height: 4.615,
    transform: "translate(0 18.461)",
    fill: "#cb001c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_429",
    "data-name": "Ret\\xE2ngulo 429",
    width: 102.842,
    height: 4.617,
    transform: "translate(0 13.847)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_430",
    "data-name": "Ret\\xE2ngulo 430",
    width: 102.842,
    height: 4.615,
    transform: "translate(0 9.231)",
    fill: "#cb001c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_431",
    "data-name": "Ret\\xE2ngulo 431",
    width: 102.842,
    height: 4.613,
    transform: "translate(0 4.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_432",
    "data-name": "Ret\\xE2ngulo 432",
    width: 102.842,
    height: 4.618,
    transform: "translate(0 0)",
    fill: "#cb001c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_433",
    "data-name": "Ret\\xE2ngulo 433",
    width: 46.966,
    height: 32.307,
    transform: "translate(0 0)",
    fill: "#2a3560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6127",
    "data-name": "Caminho 6127",
    d: "M3.173,2.077l.4,1.224H4.86l-1.041.754.4,1.221L3.173,4.522l-1.041.754.406-1.221L1.5,3.3H2.772Z",
    transform: "translate(1.07 1.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6128",
    "data-name": "Caminho 6128",
    d: "M3.173,5.224l.4,1.217H4.86l-1.041.751.4,1.227L3.173,7.664,2.132,8.42l.406-1.227L1.5,6.441H2.772Z",
    transform: "translate(1.07 3.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6129",
    "data-name": "Caminho 6129",
    d: "M3.173,8.369l.4,1.217H4.86l-1.041.754.4,1.224-1.042-.756-1.041.756.406-1.224L1.5,9.587H2.772Z",
    transform: "translate(1.07 5.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6130",
    "data-name": "Caminho 6130",
    d: "M3.173,11.513l.4,1.224H4.86l-1.041.754.4,1.217-1.042-.751-1.041.751.406-1.217L1.5,12.737H2.772Z",
    transform: "translate(1.07 8.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6131",
    "data-name": "Caminho 6131",
    d: "M3.173,14.658l.4,1.227H4.86l-1.041.747.4,1.221L3.173,17.1l-1.041.754.406-1.221L1.5,15.886H2.772Z",
    transform: "translate(1.07 10.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6132",
    "data-name": "Caminho 6132",
    d: "M5.368,3.733l.382,1.224H7.043l-1.034.758L6.4,6.932,5.368,6.181l-1.035.751.389-1.217L3.687,4.957H4.974Z",
    transform: "translate(2.633 2.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6133",
    "data-name": "Caminho 6133",
    d: "M5.368,6.88,5.751,8.1H7.043l-1.034.758L6.4,10.072,5.368,9.325l-1.035.747.389-1.217L3.687,8.1H4.974Z",
    transform: "translate(2.633 4.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6134",
    "data-name": "Caminho 6134",
    d: "M5.368,10.026l.382,1.221H7.043L6.009,12,6.4,13.221l-1.029-.754-1.035.754L4.722,12l-1.035-.754H4.974Z",
    transform: "translate(2.633 7.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6135",
    "data-name": "Caminho 6135",
    d: "M5.368,13.173l.382,1.217H7.043l-1.034.754L6.4,16.363l-1.029-.758-1.035.758.389-1.219L3.687,14.39H4.974Z",
    transform: "translate(2.633 9.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6136",
    "data-name": "Caminho 6136",
    d: "M7.579,2.077l.4,1.224H9.266l-1.041.754.4,1.221L7.579,4.522l-1.03.754.4-1.221L5.9,3.3H7.183Z",
    transform: "translate(4.216 1.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6137",
    "data-name": "Caminho 6137",
    d: "M7.579,5.224l.4,1.217H9.266l-1.041.751.4,1.227L7.579,7.664l-1.03.756.4-1.227L5.9,6.441H7.183Z",
    transform: "translate(4.216 3.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6138",
    "data-name": "Caminho 6138",
    d: "M7.579,8.369l.4,1.217H9.266l-1.041.754.4,1.224-1.047-.756-1.03.756.4-1.224L5.9,9.587H7.183Z",
    transform: "translate(4.216 5.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6139",
    "data-name": "Caminho 6139",
    d: "M7.579,11.513l.4,1.224H9.266l-1.041.754.4,1.217-1.047-.751-1.03.751.4-1.217L5.9,12.737H7.183Z",
    transform: "translate(4.216 8.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6140",
    "data-name": "Caminho 6140",
    d: "M7.579,14.658l.4,1.227H9.266l-1.041.747.4,1.221L7.579,17.1l-1.03.754.4-1.221L5.9,15.886H7.183Z",
    transform: "translate(4.216 10.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6141",
    "data-name": "Caminho 6141",
    d: "M9.774,3.733l.394,1.224H11.46l-1.046.758.4,1.217L9.774,6.181l-1.035.751.4-1.217L8.092,4.957H9.379Z",
    transform: "translate(5.78 2.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6142",
    "data-name": "Caminho 6142",
    d: "M9.774,6.88,10.168,8.1H11.46l-1.046.758.4,1.217L9.774,9.325l-1.035.747.4-1.217L8.092,8.1H9.379Z",
    transform: "translate(5.78 4.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6143",
    "data-name": "Caminho 6143",
    d: "M9.774,10.026l.394,1.221H11.46L10.415,12l.4,1.221-1.042-.754-1.035.754L9.139,12l-1.047-.754H9.379Z",
    transform: "translate(5.78 7.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6144",
    "data-name": "Caminho 6144",
    d: "M9.774,13.173l.394,1.217H11.46l-1.046.754.4,1.219-1.042-.758-1.035.758.4-1.219L8.092,14.39H9.379Z",
    transform: "translate(5.78 9.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6145",
    "data-name": "Caminho 6145",
    d: "M11.991,2.077l.4,1.224h1.275l-1.042.754.413,1.221-1.047-.754-1.041.754.394-1.221L10.316,3.3H11.6Z",
    transform: "translate(7.369 1.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6146",
    "data-name": "Caminho 6146",
    d: "M11.991,5.224l.4,1.217h1.275l-1.042.751.413,1.227-1.047-.756L10.95,8.42l.394-1.227-1.029-.751H11.6Z",
    transform: "translate(7.369 3.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6147",
    "data-name": "Caminho 6147",
    d: "M11.991,8.369l.4,1.217h1.275l-1.042.754.413,1.224-1.047-.756-1.041.756.394-1.224-1.029-.754H11.6Z",
    transform: "translate(7.369 5.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6148",
    "data-name": "Caminho 6148",
    d: "M11.991,11.513l.4,1.224h1.275l-1.042.754.413,1.217-1.047-.751-1.041.751.394-1.217-1.029-.754H11.6Z",
    transform: "translate(7.369 8.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6149",
    "data-name": "Caminho 6149",
    d: "M11.991,14.658l.4,1.227h1.275l-1.042.747.413,1.221L11.991,17.1l-1.041.754.394-1.221-1.029-.747H11.6Z",
    transform: "translate(7.369 10.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6150",
    "data-name": "Caminho 6150",
    d: "M14.186,3.733l.394,1.224h1.281l-1.035.758.389,1.217-1.029-.751-1.035.751.389-1.217L12.5,4.957h1.281Z",
    transform: "translate(8.932 2.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6151",
    "data-name": "Caminho 6151",
    d: "M14.186,6.88,14.581,8.1h1.281l-1.035.758.389,1.217-1.029-.747-1.035.747.389-1.217L12.5,8.1h1.281Z",
    transform: "translate(8.932 4.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6152",
    "data-name": "Caminho 6152",
    d: "M14.186,10.026l.394,1.221h1.281L14.826,12l.389,1.221-1.029-.754-1.035.754L13.54,12,12.5,11.246h1.281Z",
    transform: "translate(8.932 7.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6153",
    "data-name": "Caminho 6153",
    d: "M14.186,13.173l.394,1.217h1.281l-1.035.754.389,1.219-1.029-.758-1.035.758.389-1.219L12.5,14.39h1.281Z",
    transform: "translate(8.932 9.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6154",
    "data-name": "Caminho 6154",
    d: "M16.4,2.077,16.8,3.3h1.281l-1.035.754.4,1.221L16.4,4.522l-1.029.754.389-1.221L14.722,3.3H16Z",
    transform: "translate(10.515 1.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6155",
    "data-name": "Caminho 6155",
    d: "M16.4,5.224l.4,1.217h1.281l-1.035.751.4,1.227L16.4,7.664l-1.029.756.389-1.227-1.035-.751H16Z",
    transform: "translate(10.515 3.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6156",
    "data-name": "Caminho 6156",
    d: "M16.4,8.369l.4,1.217h1.281l-1.035.754.4,1.224L16.4,10.809l-1.029.756.389-1.224-1.035-.754H16Z",
    transform: "translate(10.515 5.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6157",
    "data-name": "Caminho 6157",
    d: "M16.4,11.513l.4,1.224h1.281l-1.035.754.4,1.217L16.4,13.958l-1.029.751.389-1.217-1.035-.754H16Z",
    transform: "translate(10.515 8.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6158",
    "data-name": "Caminho 6158",
    d: "M16.4,14.658l.4,1.227h1.281l-1.035.747.4,1.221L16.4,17.1l-1.029.754.389-1.221-1.035-.747H16Z",
    transform: "translate(10.515 10.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6159",
    "data-name": "Caminho 6159",
    d: "M18.589,3.733l.394,1.224h1.293l-1.041.758.4,1.217-1.042-.751-1.035.751.4-1.217-1.041-.758H18.2Z",
    transform: "translate(12.081 2.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6160",
    "data-name": "Caminho 6160",
    d: "M18.589,6.88,18.983,8.1h1.293l-1.041.758.4,1.217-1.042-.747-1.035.747.4-1.217L16.914,8.1H18.2Z",
    transform: "translate(12.081 4.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6161",
    "data-name": "Caminho 6161",
    d: "M18.589,10.026l.394,1.221h1.293L19.235,12l.4,1.221-1.042-.754-1.035.754.4-1.221-1.041-.754H18.2Z",
    transform: "translate(12.081 7.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6162",
    "data-name": "Caminho 6162",
    d: "M18.589,13.173l.394,1.217h1.293l-1.041.754.4,1.219-1.042-.758-1.035.758.4-1.219-1.041-.754H18.2Z",
    transform: "translate(12.081 9.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6163",
    "data-name": "Caminho 6163",
    d: "M20.809,2.077l.4,1.224h1.281l-1.035.754.389,1.221-1.035-.754-1.029.754.387-1.221L19.134,3.3h1.281Z",
    transform: "translate(13.667 1.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6164",
    "data-name": "Caminho 6164",
    d: "M20.809,5.224l.4,1.217h1.281l-1.035.751.389,1.227-1.035-.756L19.78,8.42l.387-1.227-1.034-.751h1.281Z",
    transform: "translate(13.667 3.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6165",
    "data-name": "Caminho 6165",
    d: "M20.809,8.369l.4,1.217h1.281l-1.035.754.389,1.224-1.035-.756-1.029.756.387-1.224-1.034-.754h1.281Z",
    transform: "translate(13.667 5.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6166",
    "data-name": "Caminho 6166",
    d: "M20.809,11.513l.4,1.224h1.281l-1.035.754.389,1.217-1.035-.751-1.029.751.387-1.217-1.034-.754h1.281Z",
    transform: "translate(13.667 8.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6167",
    "data-name": "Caminho 6167",
    d: "M20.809,14.658l.4,1.227h1.281l-1.035.747.389,1.221L20.809,17.1l-1.029.754.387-1.221-1.034-.747h1.281Z",
    transform: "translate(13.667 10.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6168",
    "data-name": "Caminho 6168",
    d: "M23,3.733l.389,1.224h1.286l-1.029.758.382,1.217L23,6.181l-1.047.751.4-1.217-1.03-.758H22.6Z",
    transform: "translate(15.233 2.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6169",
    "data-name": "Caminho 6169",
    d: "M23,6.88,23.391,8.1h1.286l-1.029.758.382,1.217L23,9.325l-1.047.747.4-1.217L21.326,8.1H22.6Z",
    transform: "translate(15.233 4.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6170",
    "data-name": "Caminho 6170",
    d: "M23,10.026l.389,1.221h1.286L23.648,12l.382,1.221L23,12.467l-1.047.754.4-1.221-1.03-.754H22.6Z",
    transform: "translate(15.233 7.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6171",
    "data-name": "Caminho 6171",
    d: "M23,13.173l.389,1.217h1.286l-1.029.754.382,1.219L23,15.605l-1.047.758.4-1.219-1.03-.754H22.6Z",
    transform: "translate(15.233 9.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6172",
    "data-name": "Caminho 6172",
    d: "M25.215,2.077,25.623,3.3H26.9l-1.035.754.4,1.221-1.047-.754-1.029.754.389-1.221L23.54,3.3H24.82Z",
    transform: "translate(16.814 1.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6173",
    "data-name": "Caminho 6173",
    d: "M25.215,5.224l.408,1.217H26.9l-1.035.751.4,1.227-1.047-.756-1.029.756.389-1.227L23.54,6.441H24.82Z",
    transform: "translate(16.814 3.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6174",
    "data-name": "Caminho 6174",
    d: "M25.215,8.369l.408,1.217H26.9l-1.035.754.4,1.224-1.047-.756-1.029.756.389-1.224L23.54,9.587H24.82Z",
    transform: "translate(16.814 5.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6175",
    "data-name": "Caminho 6175",
    d: "M25.215,11.513l.408,1.224H26.9l-1.035.754.4,1.217-1.047-.751-1.029.751.389-1.217-1.035-.754H24.82Z",
    transform: "translate(16.814 8.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6176",
    "data-name": "Caminho 6176",
    d: "M25.215,14.658l.408,1.227H26.9l-1.035.747.4,1.221L25.215,17.1l-1.029.754.389-1.221-1.035-.747H24.82Z",
    transform: "translate(16.814 10.471)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUsa);
export default __webpack_public_path__ + "static/media/flag_USA.f4ac7635a8099d25c01bb32e264d610d.svg";
export { ForwardRef as ReactComponent };